<template>
  <OptionSummary></OptionSummary>
  <section class="product-slider-section">
    <ImageSlider
      :productId="thisProduct.id"
      :imagesList="['https://witrino.com/' + thisProduct.image]"
      :score="thisProduct.score"
      :scoreReference="thisProduct.scoreReference"
      :suggestion="thisProduct.suggestion"
    ></ImageSlider>
  </section>

  <div class="product-detail-section">
    <div class="title">
      <h2>
        {{ thisProduct.name }}
      </h2>
      <hr class="title-separator" />
    </div>
    <div class="product-description-div">
      <span class="product-description" v-html="thisProduct.detail"></span>
    </div>

    <ul
      class="terms_of_sale-div product-attr-list"
      style="padding: 1rem; margin: 1.5rem; min-height: auto"
      v-if="thisProduct.rel_attr.length > 0"
    >
      <b class="title_cart">مشخصات:</b>

      <template v-for="(item, index) in thisProduct.rel_attr" :key="index">
        <ProductAttribute
          :atrr="{
            productId: thisProduct.id,
            title: item.title,
            value: item.rel_attr_val
              .map((item) => {
                return item.value;
              })
              .join('/'),
            index: index,
          }"
        ></ProductAttribute>
      </template>
    </ul>
    <div class="terms_of_sale-div" v-if="thisProduct.terms_of_sale">
      <b class="title_cart">شرایط خرید:</b>
      <span class="terms_of_sale" v-html="thisProduct.terms_of_sale"></span>
    </div>
    <form class="product-sale-list">
      <div class="price_box">
        <div class="precent_off" v-if="thisProduct.precent_off">
          <p>تخفیف:</p>
          <p class="precent_off_val">
            {{ "%" + thisProduct.precent_off }}
          </p>
        </div>
        <div class="price">
          <p>قیمت:</p>
          <div class="price_val_div">
            <p
              class="bace_price_val"
              :class="{ number_price: number_price }"
              v-if="thisProduct.precent_off"
            >
              {{ persianPrice(thisProduct.price) }}
            </p>
            <p class="offed_price_val" :class="{ number_price: number_price }">
              {{
                discountCalculation(thisProduct.price, thisProduct.precent_off)
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="attr_price_box">
        <template
          v-for="(masterItem, index) in thisProduct?.rel_attr_val_price"
          :key="index"
        >
          <template
            v-for="(item, index2) in masterItem?.rel_attr_val"
            :key="index2"
          >
            <ProductSale
              :saleMetode="{
                productId: thisProduct.id,
                metode: (masterItem.title || '') + (': ' + (item.value || '')),
                price: item.price || 0,
                attrPriceId: masterItem.id,
                valuePriceId: item?.id,
                index: index || 0,
              }"
            ></ProductSale>
          </template>

          <hr v-if="index < thisProduct?.rel_attr_val_price.length - 1" />
        </template>
      </div>
    </form>
    <transition name="fade">
      <div class="phone_list" v-if="phoneListShow">
        <a
          :href="'tel:' + themeInfo?.info?.business.phone"
          v-if="phoneChecker(themeInfo.info?.business.phone.trim())"
        >
          {{ themeInfo?.info?.business.phone }}</a
        >
        <hr />
        <a
          :href="'tel:' + themeInfo?.info?.business.mobile"
          v-if="phoneChecker(themeInfo.info?.business.mobile.trim())"
        >
          {{ themeInfo?.info?.business.mobile }}</a
        >
      </div>
    </transition>
    <transition name="zoomMsg">
      <addToCartMessage
        v-if="showAddToCartMsg"
        @show-add-to-cart-msg="(n) => (showAddToCartMsg = n)"
      />
    </transition>
    <div class="phone-div">
      <button @click="addToMyCard()" class="add-to-cart-btn">
        <img src="@/assets/img/option-cards/cart.svg" alt="" />
        ثبت درخواست
      </button>
      <button
        @click="
          call(
            this.themeInfo?.info?.business.mobile ??
              this.themeInfo?.info?.business.phone
          )
        "
        class="call-us-btn"
      >
        <img src="@/assets/img/public/phone-white.svg" alt="" />
        تماس بگیرید
      </button>
    </div>
    <template v-if="thisProduct.hasOwnProperty('metodeSell')">
      <template v-if="thisProduct?.metodeSell == 2">
        <div class="number-input">
          <p>تعداد:</p>
          <input type="text" />
        </div>
        <date-picker
          class="date_picker"
          v-model="dateRange"
          range
          :disable="['1401/06/02', '1401/06/15', '1401/06/16', '1401/06/23']"
        ></date-picker>
      </template>
    </template>
  </div>
</template>

<script>
import OptionSummary from "@/components/OptionSummary/index.vue";
import ProductAttribute from "@/components/ProductAttribute/index.vue";
import ProductSale from "@/components/ProductSale/index.vue";
import ImageSlider from "@/components/ImageSlider/index.vue";
import addToCartMessage from "@/components/addToCartMessage/index.vue";
import { productsData } from "@/repo/productsData.js";
import { digitsFaToEn } from "persian-tools2";
import { publicHelpers } from "@/public/helpers.js";
import { witrinoStorage } from "@/public/witrinoStorage.js";
import DatePicker from "vue3-persian-datetime-picker";
import { addCommas, digitsEnToFa } from "persian-tools2";

export default {
  name: "ProductDetail",
  components: {
    OptionSummary,
    ProductAttribute,
    ProductSale,
    ImageSlider,
    addToCartMessage,
    DatePicker,
  },
  mixins: [productsData, publicHelpers, witrinoStorage],
  watch: {
    themeInfo: {
      handler(newValue) {
        console.log("==============================================> newValue");
        console.log(newValue);

        console.log(this.themeInfo);
        if (this.themeInfo?.info?.products) {
          this.thisProduct = this.getProduct(
            this.themeInfo?.info?.products,
            this.$route.params.id
          )[0];
          this.setProductViewed();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    themeInfo() {
      return this.$store.getters["theme/themeInfo"];
    },
  },
  data() {
    return {
      date: null,
      thisProduct: {},
      phoneListShow: false,
      number_price: true,
      showAddToCartMsg: false,
    };
  },

  mounted() {},
  methods: {
    addToMyCard() {
      const businessID = this.themeInfo?.info?.business.id;
      const businessName = this.themeInfo?.info?.business.company_name;
      const businessImage = this.themeInfo?.info?.admin.img;
      const businessPhone =
        this.themeInfo?.info?.business.phone +
        " - " +
        this.themeInfo?.info?.business.mobile;
      const product = {
        id: this.thisProduct.id,
        name: this.thisProduct.name,
        code: this.thisProduct.code,
        price: this.thisProduct.price,
        quantity: 1,
        attrVal: [],
      };
      this.addToCard(
        businessID,
        businessName,
        businessImage,
        businessPhone,
        product
      );
      this.showAddToCartMsg = true;
    },
    getNumbers(numberStr) {
      return parseInt(numberStr.replace(/\D/g, ""));
    },
    isNumeric(str) {
      if (typeof str != "string") return false;
      return !isNaN(str) && !isNaN(parseFloat(str));
    },
    discountCalculation(price, off) {
      if (this.isNumeric(price)) {
        return this.persianPrice(price - (price * off) / 100);
      } else {
        return this.persianPrice(price);
      }
    },
    persianPrice(price) {
      if (price == "تماس بگیرید" || price == "توافقی") {
        this.number_price = false;
        return price;
      } else {
        if (price == 0 || price == "0" || price == "nan" || price == null) {
          this.number_price = false;
          return "تماس بگیرید";
        } else {
          if (typeof price == "Number") price = this.getNumbers(price);
          {
            this.number_price = true;
            return digitsEnToFa(addCommas(price));
          }
        }
      }
    },
    call(mobile) {
      if (
        this.themeInfo?.info?.business.phone &&
        this.themeInfo?.info?.business.mobile &&
        this.themeInfo?.info?.business.phone.trim() !==
          this.themeInfo?.info?.business.mobile.trim()
      ) {
        this.phoneListShow = !this.phoneListShow;
      } else {
        window.open("tel:" + digitsFaToEn(mobile));
      }
    },
    setActive(event) {
      alert(event.tagName);
      if (event.classList.contains("active")) {
        event.removeClass("active");
      } else {
        event.addClass("active");
      }
    },

    setProductViewed() {
      let paramsId = this.thisProduct.id;
      let product_viewed_list = [];
      let productViewedStr = sessionStorage.getItem("product_viewed");

      if (productViewedStr != null && productViewedStr != "") {
        product_viewed_list = productViewedStr.toString().split(",");
        if (
          !product_viewed_list.find(function (product) {
            if (product == paramsId) {
              return true;
            }
            return false;
          })
        ) {
          product_viewed_list.push(paramsId);
        }
      } else {
        product_viewed_list.push(paramsId);
      }
      sessionStorage.setItem("product_viewed", product_viewed_list.toString());
      // console.log(
      //   "sessionStorage set product_viewed => " +
      //     sessionStorage.getItem("product_viewed").toString()
      // );
      //sessionStorage.setItem("product_viewed", []);
    },
  },
  created() {},
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/pages/products/detail.css);
</style>
